import React from "react"
import { FormActionButtons } from "./FormActionButtons";
import { Divider, IconButton, makeStyles, Paper, Popper } from "@material-ui/core";
import cancelIcon from "../../images/closeIcon.svg"

const useStyles = makeStyles((theme)=>({
popper: {
    zIndex: 1,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `${theme.palette.background.paper} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.9em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 1em 1em 0',
        borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.9em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 0 1em 1em',
        borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
      },
    },
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
}}
))

function PanelDialogue(props){
    const {open, anchorEl, title, cancelFunction, submitFunction, showActionButtons = true, disableButtons, cancelText, submitText, showArrow, placement ="bottom-end", flip = false} = props;
    const classes = useStyles()
    const [arrowRef, setArrowRef] = React.useState(null);

    return(
        <Popper
            open={open}
            className={classes.popper}
            modifiers={
                        {arrow: {
                                    enabled: showArrow,
                                    element: arrowRef
                                },
                          preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'scrollParent',
                                  },
                        flip: {
                          enabled: flip
                        }
                        }
                        }
            anchorEl={anchorEl}
            placement={placement}   
        >
            {showArrow && <span className={classes.arrow} ref={setArrowRef}></span>}
            <Paper square elevation={7} style={{width: "750px"}} >    
                <div style={{padding: "0.5rem 1rem", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <span>{title}</span>
                    <IconButton onClick={cancelFunction}><img src={cancelIcon}/></IconButton>
                </div>
                <Divider orientation="horizontal" style={{width: "100%", backgroundColor: "black"}}/>
                <div style={{padding: "1rem"}}>
                    {props.children}
                </div>
                {
                    showActionButtons &&
                      <div style={{padding: "1rem"}}>
                      <FormActionButtons
                          cancelFunction={cancelFunction}
                          submitFunction={submitFunction}
                          submitText={submitText}
                          cancelText={cancelText}
                          disabled={disableButtons}
                      />
                      </div>
                }
            </Paper>
        </Popper>
    )
}

export {PanelDialogue}